module.exports = __webpack_public_path__ + "img/honda.f24cb58b.png";